export const FORM_ADAPTER_TYPES = {
  REDUX: 'redux',
  RHF: 'rhf'
};
//# sourceMappingURL=constants.js.map